<script lang="ts" setup></script>

<template>
  <section class="container learn-more">
    <div class="learn-more__title">디포스트를 더 알아보고 싶다면?</div>
    <button @click="$router.push('/service')">자세히 알아보기</button>
  </section>
</template>

<style lang="scss" scoped>
.learn-more {
  @apply px-5 py-16 bg-black3 rounded-[30px] text-center -mt-32;
  @apply flex flex-col gap-4 justify-center;
  @apply desktop:gap-8 desktop:px-14 desktop:py-20 desktop:-mt-40;
  background: url("https://dvercorp-co-kr.imgix.net/dpost/home/learn_more.png?auto=compress&w=1200")
    no-repeat right center;
  background-size: cover;

  &__title {
    @apply text-black8 font-semibold text-xl;
    @apply desktop:text-left desktop:text-3xl;
  }

  button {
    @apply w-fit mx-auto text-sm;
    @apply bg-white text-black9 px-6 py-4 h-fit rounded-xl;
    @apply desktop:mx-20 desktop:text-xl;

    &:hover {
      @apply transition-all;
    }
  }
}
</style>
